module.exports = __webpack_public_path__ + "img/95.5fcbd5eb.png";